import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PayService } from 'src/app/service/pay.service';

function passwordMatchValidator(g: UntypedFormGroup) {
  return g.get('password').value === g.get('confirmPassword').value
    ? null : { 'mismatch': true };
}

@Component({
    selector: 'app-ajouter-partenaire',
    templateUrl: './ajouter-partenaire.component.html',
    styleUrls: ['./ajouter-partenaire.component.css'],
    standalone: false
})
export class AjouterPartenaireComponent implements OnInit {
  partenaireForm: UntypedFormGroup;
  partenaireList: any;

  constructor(private userService: PayService) { }

  ngOnInit(): void {
    this.ngpartenaireForm();
    this.findPartenaires();
  }




  ngpartenaireForm() {
    this.partenaireForm = new UntypedFormGroup({
      firstName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.minLength(3)]),
      email: new UntypedFormControl('', [Validators.required, Validators.pattern("[^ @]*@[^ @]*[.][^ @]{2,}")]),
      phone: new UntypedFormControl('', [Validators.required, Validators.pattern("[1-9][0-9]*"), Validators.pattern('(^(65)[0-9]{1}[0-9]{6}|^(69|66|67|64)[0-9]{7})$')]),
      password: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
      confirmPassword: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]{6}')]),
      quartier:new UntypedFormControl('', [Validators.required]),
      nidentification:new UntypedFormControl('', [Validators.required]),
      etsbancaire:new UntypedFormControl('', [Validators.required]),
      ville:new UntypedFormControl('', [Validators.required])
    }, passwordMatchValidator)
  }

  editer(p)
  {
    this.partenaireForm.get('firstName').setValue(p.firstName);
    this.partenaireForm.get('lastName').setValue(p.lastName);
    this.partenaireForm.get('email').setValue(p.username);
    this.partenaireForm.get('phone').setValue(p.phone);
    this.partenaireForm.get('quartier').setValue(p.quartier);
    this.partenaireForm.get('nidentification').setValue(p.nidentification);
    this.partenaireForm.get('etsbancaire').setValue(p.etsbancaire);
    this.partenaireForm.get('ville').setValue(p.ville);
  }

  addpartenaire(formdata)
  {
    this.userService.ajouterPartenaire(formdata).subscribe(data=>{
   
    this.findPartenaires();
    })

  }

  findPartenaires()
  {
    this.userService.afficherPartenaires().subscribe((data:any[])=>{
      this.partenaireList=data;
     
    })
  }

}
